import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Jenkins',
  role: 'Marketing Director',
  company: 'TechFlow UK',
  content: 'Since working with SEO PPC Co, our organic traffic has tripled. Their team is responsive, knowledgeable, and truly cares about our success. Highly recommended.',
  rating: 5
}, {
  name: 'David Miller',
  role: 'Founder',
  company: 'Miller & Sons',
  content: 'The PPC campaigns they set up transformed our lead generation overnight. We went from struggling to find leads to having to hire more sales staff.',
  rating: 5
}, {
  name: 'Emma Thompson',
  role: 'CEO',
  company: 'BrightStart Education',
  content: 'Professional, transparent, and effective. I love the monthly reports that show exactly where our budget is going and the ROI we are getting.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-24 bg-white" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-178">
            What Our Clients Say
          </h2>
          <p className="text-lg text-slate-600" data-id="element-179">
            Don't just take our word for it. Here is what UK business owners
            think.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-180">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-slate-50 p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-181">
              <div className="flex gap-1 mb-4" data-id="element-182">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-183" />)}
              </div>
              <p className="text-slate-700 mb-6 italic" data-id="element-184">
                "{testimonial.content}"
              </p>
              <div data-id="element-185">
                <p className="font-bold text-slate-900" data-id="element-186">{testimonial.name}</p>
                <p className="text-sm text-slate-500" data-id="element-187">
                  {testimonial.role}, {testimonial.company}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}